import { Navigate } from 'react-router-dom';
import Home from "~/features/Home/pages";
import PageNotFound from "../features/NotFound/pages";
import AccountInfo from "~/features/Account/pages/AccountInfo";
import AccountPassword from "../features/Account/pages/AccountPassword";
import Permission from "~/features/Permission/pages/Permission";
import SeoCheck from "~/features/SeoCheck/pages/SeoCheck";
import SeoHistory from "~/features/SeoCheck/pages/SeoHistory";
import PageSpeed from "~/features/PageSpeed/pages/PageSpeed";
import PageSpeedHistory from "~/features/PageSpeed/pages/PageSpeedHistory";
import SchemaGenerator from "~/features/SchemaTool/pages/SchemaGenerator";
import SchemaValidator from "~/features/SchemaTool/pages/SchemaValidator";
import SchemaSaved from "~/features/SchemaTool/pages/SchemaSaved";
import ProjectList from "~/features/Project/pages/ProjectList";
import ProjectDashboard from "~/features/Project/pages/ProjectDashboard";
import CrawlerHome from "~/features/SiteCrawler/pages/CrawlerHome";
import CrawlReport from "~/features/SiteCrawler/pages/CrawlReport";
import CrawlPageDetail from "~/features/SiteCrawler/pages/CrawlPageDetail";
import GscHome from "~/features/GscInsight/pages/GscHome";
import GscCallback from "~/features/GscInsight/pages/GscCallback";
import TechnicalHome from "~/features/Technical/pages/TechnicalHome";
import AiTool from "~/features/AiTool/pages/AiTool";
import AiHistory from "~/features/AiTool/pages/AiHistory";
import AiProjectHome from "~/features/AiTool/pages/AiProjectHome";
import SubscriptionPage from "~/features/Subscription/pages/SubscriptionPage";
import MemberList from "~/features/Member/pages/MemberList";
import MemberDetail from "~/features/Member/pages/MemberDetail";
import PlanManager from "~/features/Member/pages/PlanManager";
import AdminStats from "~/features/Member/pages/AdminStats";

// Quyền cho phép truy cập cụm Dự án (giống điều kiện hiện menu ở NavBarData).
const PROJECT_CAPS = ['project', 'crawl', 'gsc', 'ai'];

/**
 * `cap`: quyền yêu cầu để vào route (string hoặc mảng = có 1 trong số đó; root luôn qua).
 * Không khai báo = ai đăng nhập cũng vào được. App.js bọc <RequireCap> khi route có cap
 * → không có quyền thì hiện màn NoPermission thay vì vào trang rồi nhận lỗi API.
 */
export const privateRoutes = [
	{ path: "/", component: Home },
	{ path: "*", component: PageNotFound },
	// Hồ sơ cá nhân (thông tin tài khoản)
	{ path: "/profile", component: AccountInfo },
	// Trang hồ sơ cũ → chuyển hướng sang trang Hồ sơ cá nhân
	{ path: "/account/info", component: () => <Navigate to={process.env.REACT_APP_HOMEPAGE + "/profile"} replace /> },
	{ path: "/account/password", component: AccountPassword },
	{ path: "/permission", component: Permission, cap: 'permission' },
	// Chấm điểm SEO
	{ path: "/seo", component: SeoCheck, cap: 'seo' },
	{ path: "/seo/history", component: SeoHistory, cap: 'seo' },
	// PageSpeed / Core Web Vitals
	{ path: "/pagespeed", component: PageSpeed, cap: 'pagespeed' },
	{ path: "/pagespeed/history", component: PageSpeedHistory, cap: 'pagespeed' },
	// AI SEO (độc lập)
	{ path: "/ai", component: AiTool, cap: 'ai' },
	{ path: "/ai/history", component: AiHistory, cap: 'ai' },
	// Schema.org Generator + Validator
	{ path: "/schema/generator", component: SchemaGenerator, cap: 'schema' },
	{ path: "/schema/validator", component: SchemaValidator, cap: 'schema' },
	{ path: "/schema/saved", component: SchemaSaved, cap: 'schema' },
	// Dự án (thực thể tổng) + công cụ bên trong
	{ path: "/projects", component: ProjectList, cap: PROJECT_CAPS },
	{ path: "/projects/:id", component: ProjectDashboard, cap: PROJECT_CAPS },
	// Tool Site Crawler trong 1 dự án
	{ path: "/projects/:id/crawler", component: CrawlerHome, cap: 'crawl' },
	{ path: "/crawler/crawls/:id", component: CrawlReport, cap: 'crawl' },
	{ path: "/crawler/pages/:id", component: CrawlPageDetail, cap: 'crawl' },
	// Tool Kỹ thuật SEO trong 1 dự án (báo cáo kỹ thuật từ lần crawl mới nhất)
	{ path: "/projects/:id/technical", component: TechnicalHome, cap: 'crawl' },
	// Tool Google Search Console trong 1 dự án + đích redirect OAuth
	{ path: "/projects/:id/gsc", component: GscHome, cap: 'gsc' },
	{ path: "/gsc/oauth/callback", component: GscCallback, cap: 'gsc' },
	// Tool AI SEO trong 1 dự án (Trợ lý AI phân tích dữ liệu + Sinh nội dung)
	{ path: "/projects/:id/ai", component: AiProjectHome, cap: 'ai' },
	// Gói & Hạn mức của chính user (mọi user đều xem được gói của mình)
	{ path: "/subscription", component: SubscriptionPage },
	// Quản trị thành viên & gói (cần cap member_manage)
	{ path: "/admin/stats", component: AdminStats, cap: 'member_manage' },
	{ path: "/admin/members", component: MemberList, cap: 'member_manage' },
	{ path: "/admin/members/:id", component: MemberDetail, cap: 'member_manage' },
	{ path: "/admin/plans", component: PlanManager, cap: 'member_manage' },
];

export function PrivateRoutes({children}) {
	// Check if user is logged in
	// If yes, show route
	// Otherwise, redirect to login page
	const isLoggedIn = Boolean(localStorage.getItem('access_token'));

	if (!isLoggedIn) return <Navigate to={process.env.REACT_APP_HOMEPAGE + "/login"} />;

	return children;
}
